module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/close.png
// module id = 1310
// module chunks = 438